module.exports = __webpack_public_path__ + "img/apunt.789ade6a.svg";